// extracted by mini-css-extract-plugin
export default {"featureAppLoader":"WncRfkz","first":"uTyJkLw","noMargins":"bLFJnXg","bannerVisible":"ihG6dkn","loaderWrapper":"lIyFhQt"};